import { c as _c } from "react/compiler-runtime";
import { TaxUnit, TaxYearlyReportUnits } from "../../../../../models";
import { thousandize } from "../../../../../util/formatting";
import style from "./TaxYearlyReportDesktopDetails.module.scss";
export const TaxYearlyReportDesktopDetails: React.FC<{
  channels: {
    channel: string;
    sumDonations: number;
  }[];
  unit?: TaxYearlyReportUnits;
}> = t0 => {
  const $ = _c(7);
  const {
    channels,
    unit
  } = t0;
  let t1;
  if ($[0] !== channels || $[1] !== unit) {
    let t2;
    if ($[3] !== unit) {
      t2 = channel => <tr key={channel.channel + "-" + (unit ? unit.id : "missing")}><td>{"Gitt gjennom " + channel.channel}</td><td>{thousandize(channel.sumDonations)} kr</td></tr>;
      $[3] = unit;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = channels.map(t2);
    $[0] = channels;
    $[1] = unit;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <table className={style.table} cellSpacing="0"><tbody>{t1}</tbody></table>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};